import React, {Component} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import SearchField from "../SearchField";

/**
 * field pro filtrování podepisujících
 */
class QsignPodepisujiciField extends Component<any> {
    static propTypes = {
        empty: PropTypes.bool,
        onChange: PropTypes.func,

    };
    static defaultProps = {
        empty: true,
    };


    render() {
        const {onChange} = this.props

        return (
            <SearchField
                onChange={(value) => onChange(value)}
                placeholder={"Zafiltrovat uživatele"}
            />
        );
    }
}

export default connect((state) => {
    return state;
})(QsignPodepisujiciField);
